import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../user/auth/context/auth-context';
import FeedbackMenuButton from '../../feedback/components/feedback-menu-button/menu-feedback-button';
import NudgesHeader from '../../headers/nudges-header/nudges-header';
import PageWrapper from '../page-wrapper/page-wrapper';
import './nudges-page.scss';

/**
 * Renders a <NudgesPage /> component
 * @param {object} props
 * @param {string} props.className - classnames to add to the root of this component
 * @param {Object} props.children - the content to render in the page
 * @param {boolean} props.selectedLink - display or not the footer
 * @param {boolean} props.hideNav - display or not the nav buttons
 */
const NudgesPage = (props) => {
	const { className = '', children, selectedLink = 0, hideNav = false, overrideRoles } = props;
	const { user } = useContext(AuthContext);

	const allowedRoles = overrideRoles || ['localAdmin', 'admin'];
	const navigate = useNavigate();

	if (!user?.role || !allowedRoles.includes(user.role)) {
		return navigate('/error-access');
	}

	return (
		<PageWrapper className="nudges-page">
			<NudgesHeader selectedLink={selectedLink} hideNav={hideNav} />

			<main className={`nudges-page__content ${className}`}>{children}</main>
			<FeedbackMenuButton />
		</PageWrapper>
	);
};

NudgesPage.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	selectedLink: PropTypes.number,
	hideNav: PropTypes.bool,
};

export default NudgesPage;
